<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-account-convert</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">外注作業者情報編集</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="subcontractor_form" v-model="valid" @submit.prevent>
              <v-text-field label="氏名" v-model="name" :rules="subcontractorNameRules" dense outlined></v-text-field>
              <v-select label="取引先" v-model="supplier" :rules="suppliersRules" item-text="name" item-value="id" :items="suppliers" no-data-text="データがありません" dense outlined return-object/>
              <v-text-field label="単価" v-model.number="unit_price" :rules="unitPriceRules" dense outlined></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'SubcontractorMaster' }" depressed>キャンセル</v-btn>
            <v-btn color="success" @click.prevent="checkDialog" :disabled="!valid" depressed>更新</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleUpdate
        @updated="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import SubcontractorApi from "@/api/subcontractor-api";
  import CustomDialog from "@/components/custom_ui/CustomDialog";
  import Rule from "@/validation/rules";

  export default {
    name: "EditSubcontractorMaster",
    components: {
      CustomDialog
    },
    data: () => ({
      loading: false,
      // フォームの項目
      name: '',
      supplier: '',
      unit_price: '',

      // プルダウン項目
      subcontractor_types: '',
      suppliers: '',

      // 更新ダイアログ
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,
      editId: null,

      // バリデーション
      valid: true,
      subcontractorNameRules: Rule.subcontractorNameRules,
      suppliersRules: Rule.suppliersRules,
      unitPriceRules: Rule.unitPriceRules,
    }),
    created () {
      this.initialize();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        this.subcontractorApi = new SubcontractorApi();
        // 外注作業者IDをルートパラメータから取得
        this.editId = this.$route.params.id;
        const promise = this.subcontractorApi.info(this.editId);
        promise.then(response => {
            this.name = response.data.body.subcontractor_info.name;
            this.unit_price = response.data.body.subcontractor_info.unit_price;
            this.suppliers = response.data.body.suppliers_list;
            this.supplier = this.suppliers.find((v) => v.id === response.data.body.subcontractor_info.suppliers_id);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
      // 更新ボタン押下時イベント
      checkDialog () {
        this.dialogTitle = '更新しますか？';
        this.dialogItems = [
          { name: '氏名', value: this.name },
          { name: '取引先', value: this.supplier.name },
          { name: '単価', value: this.unit_price },
        ];
        this.dialogDrawer = true;
      },
      dialogCancel() {
        this.dialogDrawer = false;
      },
      // 確認ダイアログの「更新」確定ボタン押下イベント
      submit() {
        if (this.$refs.subcontractor_form.validate()) {
          this.isLoading();
          const params = {
            name: this.name,
            suppliers_id: this.supplier.id,
            unit_price: this.unit_price,
          };
          const promise = this.subcontractorApi.update(this.editId, params);
          promise.then((response) => {
              this.$router.push({ name: 'SubcontractorMaster' });
              this.$emit('success', response.data.message);
          }).catch(error => {
            useAppInsights().trackException({exception: error});
            if(error.response){
              this.$emit("error",error.response.data.message);
            }else{
              this.$emit("error","サーバーエラーが発生しました。");
            }
          }).finally(() => {
            this.isLoading();
          });
        }
      }
    },
  };
</script>
